import { EMOJI_MARKER_LABEL } from "../../../../redux/markers/constants";

const reactionRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;

export const getAllReactions = () => [
  { unicode: "\u2764\ufe0f", label: i18n.t("emoji-reactions.heart-emoji") },
  { unicode: "\uD83D\uDC40", label: i18n.t("emoji-reactions.eyes-emoji") },
  { unicode: "\ud83d\ude00", label: i18n.t("emoji-reactions.grinning-emoji") },
  { unicode: "\uD83E\uDD14", label: i18n.t("emoji-reactions.thinking-emoji") },
  { unicode: "\uD83D\uDE31", label: i18n.t("emoji-reactions.scared-emoji") }
];

export const getEmojiMatch = string => string.match(reactionRegex);

export const isReaction = string => !!getEmojiMatch(string);

export const getEmoji = string => {
  const match = getEmojiMatch(string);
  return match && match[0];
};

export const isEmojiMarker = marker =>
  marker && marker.label === EMOJI_MARKER_LABEL;
